goog.provide('el8.ptdata.ptFamilyRelationships');

// goog.require('el8.template.ptdata.ptFamilyRelationships');
goog.require('el8.model.base');
goog.require('el8.ptdata.familyRelationshipItems');
goog.require('el8.ptdata.model.PatientItemSet');

el8.ptdata.ptFamilyRelationships = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);
        
        // pluck out just the IDs and store the object itself separately
        if (spec.items) {
          el8.ptdata.familyRelationshipItems.create(spec.items, true);
          this.setItemIds(_.pluck(spec.items, 'id'));
        }
    };
    _class.addIntProperty('relationshipType', true);
    _class.addIntProperty('rank');
    _class.addProperty('itemIds');

    _class.prototype.getItems = function() {
        return this.getItemIds().map(function(id) {
            return el8.ptdata.familyRelationshipItems.getById(id);
        });
    };

    _class.prototype.getRelationshipTypeName = function() {
        if (!el8.data.familyRelationships.length) { return null; }

        var relationshipType = this.getRelationshipType();
        var matchingStruct = _.find(el8.data.familyRelationships, function(struct) {
            return (struct[0] === relationshipType);
        });
        return (matchingStruct) ? matchingStruct[1] : null;
    };

    var that = new el8_EntitySet({
        model: function(spec) {
            return new _class(spec);
        },
        urlLoad: function() { return el8.service.urls.get('ptFamilyRelationships'); },
        sortFn: function(a, b){ return a.getRank()-b.getRank(); },
        saveFn: function(item, successCbFn) {
            el8.appservice.notifier.notify('New patient relationship being added...');
            $.el8_ajax({
                url: el8.service.urls.get('ptFamilyRelationships', [item]),
                type: 'POST',
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    if (item.getId()) {
                        el8.ptdata.ptFamilyRelationships.updateItemId(item, data.id);
                    }
                    item.populate(data);
                    if (successCbFn) { successCbFn(item); }
                    el8.appservice.notifier.notify('New patient relationship added.');
                }
            });
        },
        deleteFn: function(item, successCbFn) {
            el8.appservice.notifier.notify('Deleting patient relationship...');
            $.el8_ajax({
                url: el8.service.urls.get('ptFamilyRelationships', [item]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Patient relationship deleted.');
                    if (successCbFn) { successCbFn(item); }
                }
            });
        }
    });

    that.getAllItems = function() {
        return _.flatten(that.sorted().map(function(relationship) {
            return relationship.getItems();
        }));
    };

    return that;

})();

